<template>
  <div class="Skelet-Avt" :style="get_styleValue"></div>
</template>

<script setup>
  import { computed } from 'vue';
  import { Props } from './scripts/props.js';
  //---------------------------------
  const props = defineProps(Props());
  //---------------------------------
  const get_styleValue = computed(() => `
    max-height: ${props.size}px;
    max-width: ${props.size}px;
    min-width: ${props.size}px;
    min-height: ${props.size}px;
  `);
</script>

<style lang="scss">
  @import "./styles/_styles";
</style>